export function getAuthToken() {
  try {
    const authStorage = localStorage.getItem("auth-storage");
    if (authStorage) {
      const parsed = JSON.parse(authStorage);
      return parsed?.state?.user?.token?.token || "";
    }
  } catch (e) {
    console.error("Failed to parse auth-storage for token:", e);
  }
  return "";
}

export function getRestaurantId() {
  try {
    const authStorage = localStorage.getItem("auth-storage");
    if (authStorage) {
      const parsed = JSON.parse(authStorage);
      return parsed?.state?.restaurantId || "";
    }
  } catch (e) {
    console.error("Failed to parse auth-storage for restaurantId:", e);
  }
  return "";
}

export function getRestaurantIdWithAuthToken() {
  return {
    restaurantId: getRestaurantId(),
    token: getAuthToken()
  }
}


const prepareNewUserData = (branchData, restaurants) => {
  return {
    acceptPayAfterEat: branchData.acceptPayAfterEat,
    defaultBranchId: branchData.restaurantId,
    defaultBranchRole: branchData.role,
    inventoryType: branchData.inventoryType,
    isVatIncluded: branchData.isVatIncluded,
    isSuperAdmin: false,
    kitchenSlipOnly: branchData.kitchenSlipOnly,
    orderCreateViewType: 'GRID',
    restaurants
  }
};

export const getAllBranchListLoggedInUser = (restaurants) => {
  const allBranches = [];

  for (let i = 0; i < restaurants.length; i++) {
    const branches = restaurants[i].branches;

    for (let j = 0; j < branches.length; j++) {
      const item = branches[j];
      allBranches.push(item);
    }
  }

  return allBranches;
};

export const isDefaultBranchExistInBranches = (defaultBranchId, allRestaurants) => {
  const allBranches = getAllBranchListLoggedInUser(allRestaurants);

  return allBranches.some(item => item.restaurantId === defaultBranchId);
}

export const prepareUserDataForSessionUpdate = (currentUser, currentBranchId, restaurants) => {
  const allBranches = getAllBranchListLoggedInUser(restaurants);
  let branchData = allBranches.find(item => item.restaurantId === currentBranchId);

  const newUserData = prepareNewUserData(branchData, restaurants);

  return {
    ...currentUser,
    ...newUserData
  };  
}